import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { Layout, Badge, Menu, Dropdown, Button, message, Input } from 'antd';
import { DownOutlined, UserOutlined, RightOutlined } from '@ant-design/icons';
import { setProfileState } from 'actions/profile';
import { logout } from 'actions/auth';
import { Tooltip } from 'reactstrap';

import { UserMenu } from 'components/user/UserMenu'
import { REDIRECT_DOMAIN_PATH } from 'DataSet';
import * as AuthUtils from 'common/auth-utils'


const Logo = '/assets/images/MagnifiLogo/Magnifi_Logo_Charcoal_RGB.png'

const { Header } = Layout;

class MHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pathname: this.props.location.pathname
    }
  }

  handleGoToLogin = () => {
    this.props.history.push('/login')
  }

  handleLogout = (event) => {
    event.preventDefault()
    const payload = {
      email: this.props.user.email
    }
    this.props.logout(payload);
  }


  render() {
    const { location, height, query, loggedIn, loggingIn, logoutHandler, logo} = this.props;

    const { pathname } = location;

    let LOGO_WILL_BE = '/assets/images/MagnifiLogo/Magnifi_Logo_Charcoal_RGB.png';

    console.log(pathname.startsWith("Hello"));

    return (
      <React.Fragment>
        <Header id="magnifi-header-wrapper" className="magnifi-header-wrapper headerWrapper">

              <a className="navbar-brand logoWrapper" href={REDIRECT_DOMAIN_PATH}>
                <img
                  className="brand-logo"
                  src={LOGO_WILL_BE}
                  width={height ? '' : '162'}
                  height={height}
                  alt="magnifi"
                />
              </a>


              <div className="header-middle">
                
                <Link to="/accounts" className={pathname.startsWith("/account") ? "trading-button current-selected" : "trading-button"}>Trading Accounts</Link>

                <Link to="/trades" className={pathname.startsWith("/trade") ? "trading-button current-selected" : "trading-button"}>Trade Basket</Link>
                <Link to="/notifications" className={pathname.startsWith("/notifications") ? "trading-button current-selected" : "trading-button"}>Error Accounts</Link>
                <Link to="/sponsers" className={pathname.startsWith("/sponsers") ? "trading-button current-selected" : "trading-button"}>Sponsors</Link>

              </div>
              <div className="profile-anchor">
              <nav className="navbar navbar-expand-md navbar-dark bg-c5 py-0 shadow-0 navBarWrapper">
                <div className="container py-1">
                  <UserMenu
                    className="user-menu-popover "
                    onLogout={this.handleLogout} isLoggedIn={this.props.loggedIn}
                    showSinginIcon={this.props.isLoggedIn}
                    showSinginIcon={this.props.isLoggedIn}
                  />
              </div>
            </nav>
            </div>
        </Header>
      </React.Fragment>
    )
  }
}

Header.propType = {
  onLogout: PropTypes.func.isRequired
}

const mapStateToProps = ({ auth,profile }) => ({
  useremail: auth.user.email,
  firstName: auth.user.firstName,
  lastName: auth.user.lastName,


  loggingIn: auth.loggingIn,

  loggedIn: auth.loggedIn,
  authSuccess: auth.authSuccess,
  authFailed: auth.authFailed,
  user: auth.user,
  logoutSuccess: auth.logoutSuccess,
  //logo: profile.logo,

});

const mapDispatchToProps = {
  logoutHandler: logout,
  logout
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MHeader);
